import { render, staticRenderFns } from "./PollVotersDetails.vue?vue&type=template&id=21abaa62&scoped=true"
import script from "./PollVotersDetails.vue?vue&type=script&lang=js"
export * from "./PollVotersDetails.vue?vue&type=script&lang=js"
import style0 from "./PollVotersDetails.vue?vue&type=style&index=0&id=21abaa62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abaa62",
  null
  
)

export default component.exports